import { jsxs, jsx } from "react/jsx-runtime";
import "react";
import { P as PropTypes } from "./index-qdNxdI8l.js";
import { css, cx } from "@emotion/css";
import { useTheme } from "@emotion/react";
const base = css`
  gap: 8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 360px;
  cursor: pointer;
  outline: none;
  font-family: "myriad-pro", sans-serif;
  text-decoration: none;
  font-weight: 600;

  span {
    display: flex;
  }

  svg {
    width: 24px;
    height: 24px;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px #13496D;
    transition: box-shadow 0.1s ease;
  }
`;
let rawVariantRules = {
  small: `
    height: 48px;
    padding: 12px 24px;
    font-size: 16px;
  `,
  medium: `
    font-size: 18px;
    height: 56px;
    padding: 16px 32px;
  `
};
rawVariantRules = {
  ...rawVariantRules,
  "small-icon-single": `
    padding: 4px;
    height: auto;
  `,
  "small-icon-left": `
    ${rawVariantRules.small}
    padding-left: 16px;
  `,
  "small-icon-right": `
    ${rawVariantRules.small}
    padding-right: 16px;
  `,
  "medium-icon-single": `
    padding: 12px;
    height: auto;
  `,
  "medium-icon-left": `
    ${rawVariantRules.medium}
    padding-left: 24px;
  `,
  "medium-icon-right": `
    ${rawVariantRules.medium}
    padding-right: 24px;
  `
};
const small = css(rawVariantRules.small);
const smallIconSingle = css(rawVariantRules["small-icon-single"]);
const smallIconLeft = css(rawVariantRules["small-icon-left"]);
const smallIconRight = css(rawVariantRules["small-icon-right"]);
const medium = css(rawVariantRules.medium);
const mediumIconSingle = css(rawVariantRules["medium-icon-single"]);
const mediumIconLeft = css(rawVariantRules["medium-icon-left"]);
const mediumIconRight = css(rawVariantRules["medium-icon-right"]);
const navFilled = (theme) => {
  var _a, _b, _c, _d, _e, _f;
  return css`
  color: ${(_a = theme.vars.palette.primary) == null ? void 0 : _a["contrastText"]};
  background: ${(_b = theme.vars.palette.primary) == null ? void 0 : _b[90]};

  svg {
    fill: ${(_c = theme.vars.palette.primary) == null ? void 0 : _c["contrastText"]};
  }

  &:hover {
    background: ${(_d = theme.vars.palette.primary) == null ? void 0 : _d[100]};
  }

  &:focus-visible {
    border: none;
    background:  ${(_e = theme.vars.palette.primary) == null ? void 0 : _e[100]};
  }

  &:active {
    border: 0px;
    background:  ${(_f = theme.vars.palette.primary) == null ? void 0 : _f[110]};
  }
`;
};
const navOutline = (theme) => {
  var _a, _b, _c, _d, _e, _f, _g;
  return css`
  color: ${(_a = theme.vars.palette.primary) == null ? void 0 : _a[110]};
  background: transparent;
  border: 1px solid ${(_b = theme.vars.palette.grey) == null ? void 0 : _b[80]};

  svg {
    fill: ${(_c = theme.vars.palette.primary) == null ? void 0 : _c[110]};
  }

  &:hover {
    background: ${(_d = theme.vars.palette.transparent) == null ? void 0 : _d["light30"]}
  }

  &:focus-visible {
    border: none;
    background:  ${(_e = theme.vars.palette.transparent) == null ? void 0 : _e["light30"]}
  }

  &:active {
    border: 1px solid  ${(_f = theme.vars.palette.grey) == null ? void 0 : _f[80]};
    background:  ${(_g = theme.vars.palette.transparent) == null ? void 0 : _g["medium30"]}
  }
`;
};
const navText = (theme) => {
  var _a, _b, _c, _d, _e;
  return css`
  color: ${(_a = theme.vars.palette.primary) == null ? void 0 : _a[110]};
  background-color: transparent;

  svg {
    fill: ${(_b = theme.vars.palette.primary) == null ? void 0 : _b[110]};
  }

  &:hover {
    background: ${(_c = theme.vars.palette.transparent) == null ? void 0 : _c["light30"]}
  }

  &:focus-visible {
    border: none;
    background:  ${(_d = theme.vars.palette.transparent) == null ? void 0 : _d["light30"]}
  }

  &:active, &.is-pressed{
    border: 0;
    background:  ${(_e = theme.vars.palette.transparent) == null ? void 0 : _e["medium30"]}
  }
`;
};
const filled = (theme) => {
  var _a, _b, _c, _d;
  return css`
  color: #fff;
  background: ${(_a = theme.vars.palette.green) == null ? void 0 : _a[90]};

  svg {
    fill: #fff;
  }

  button & {
    color: #fff;
  }

  &:hover {
    background: ${(_b = theme.vars.palette.green) == null ? void 0 : _b[100]};
  }

  &:focus-visible {
    border: none;
    background:  ${(_c = theme.vars.palette.green) == null ? void 0 : _c[100]};
  }

  &:active {
    background:  ${(_d = theme.vars.palette.green) == null ? void 0 : _d[110]};
  }
`;
};
const outline = (theme) => {
  var _a, _b, _c, _d, _e, _f, _g;
  return css`
  color: ${(_a = theme.vars.palette.green) == null ? void 0 : _a[110]};
  background: transparent;
  border: 1px solid  ${(_b = theme.vars.palette.grey) == null ? void 0 : _b[80]};

  svg {
    fill: ${(_c = theme.vars.palette.green) == null ? void 0 : _c[110]};
  }

  &:hover {
    background: ${(_d = theme.vars.palette.transparent) == null ? void 0 : _d["light30"]}
  }

  &:focus-visible {
    border: none;
    background:  ${(_e = theme.vars.palette.transparent) == null ? void 0 : _e["light30"]}
  }

  &:active {
    border: 1px solid  ${(_f = theme.vars.palette.grey) == null ? void 0 : _f[80]};
    background:  ${(_g = theme.vars.palette.transparent) == null ? void 0 : _g["medium30"]}
  }
`;
};
const text = (theme) => {
  var _a, _b, _c, _d, _e;
  return css`
  color: ${(_a = theme.vars.palette.green) == null ? void 0 : _a[110]};
  background: transparent;

  svg {
    fill: ${(_b = theme.vars.palette.green) == null ? void 0 : _b[110]};
  }

  &:hover {
    background: ${(_c = theme.vars.palette.transparent) == null ? void 0 : _c["light30"]}
  }

  &:focus-visible {
    border: none;
    background:  ${(_d = theme.vars.palette.transparent) == null ? void 0 : _d["light30"]}
  }

  &:active, &.is-pressed {  
    border: 0;
    background:  ${(_e = theme.vars.palette.transparent) == null ? void 0 : _e["medium30"]}
  }
`;
};
const critical = (theme) => {
  var _a, _b, _c;
  return css`
  color: #fff;
  background: ${(_a = theme.vars.palette.red) == null ? void 0 : _a[90]};

  svg {
    fill: #fff;
  }

  button & {
    color: #fff;
  }

  &:hover {
    background: ${(_b = theme.vars.palette.red) == null ? void 0 : _b[100]};
  }

  &:focus-visible {
    border: none;
    background:  ${(_c = theme.vars.palette.red) == null ? void 0 : _c[100]};
  }

  &:active {
    border: 0;
    background:  #8B0E15;
  }
`;
};
const outlinedIcon = (theme) => {
  var _a;
  return css`
  ${outline(theme)}
  border: 1px solid ${(_a = theme.vars.palette.grey) == null ? void 0 : _a[100]};
  svg {
    fill: #333
  }
  `;
};
const icon = (theme) => css`
  ${text(theme)}
  svg {
    fill: #333
  }
  `;
const buttonStyles = {
  base,
  variant: {
    small,
    "small-icon-left": smallIconLeft,
    "small-icon-right": smallIconRight,
    "small-icon-single": smallIconSingle,
    medium,
    "medium-icon-left": mediumIconLeft,
    "medium-icon-right": mediumIconRight,
    "medium-icon-single": mediumIconSingle
  },
  type: {
    "nav-filled": navFilled,
    "nav-outline": navOutline,
    "nav-text": navText,
    filled,
    outline,
    text,
    critical,
    "outline-icon": outlinedIcon,
    icon
  }
};
const responsiveStyles = ({ theme, breakpoints }) => {
  let cssVariant = "";
  if (Array.isArray(breakpoints)) {
    breakpoints.forEach((breakpoint) => {
      if (typeof breakpoint.container !== "undefined") {
        cssVariant = `${cssVariant}
        ${theme.containerQueries(breakpoint.container).up(breakpoint.size)} {
          ${rawVariantRules[breakpoint.variant]}
        }
        `;
      } else {
        cssVariant = `${cssVariant}
        ${theme.breakpoints.up(breakpoint.size)} {
          ${rawVariantRules[breakpoint.variant]}
        }
        `;
      }
    });
    cssVariant = css(cssVariant);
  }
  return {
    base,
    variant: cssVariant
  };
};
function ButtonIcon({ icon: icon2, testId }) {
  return /* @__PURE__ */ jsx("span", { "data-testid": testId, children: icon2 });
}
function Button({
  as = "button",
  variant,
  type,
  iconLeft,
  iconRight,
  className = "",
  htmlType,
  testId,
  iconTestId,
  onClick,
  children,
  breakpoints,
  isPressedState = false,
  tabIndex = 0,
  ...rest
}) {
  const theme = useTheme();
  function hasIcon(iconLeft2, iconRight2, variant2) {
    if (iconLeft2 && !children) {
      return `${variant2}-icon-single`;
    }
    if (iconLeft2) {
      return `${variant2}-icon-left`;
    }
    if (iconRight2) {
      return `${variant2}-icon-right`;
    } else {
      return variant2;
    }
  }
  const formattedBreakpoints = breakpoints == null ? void 0 : breakpoints.map((breakpoint) => {
    const adjustedVariant = hasIcon(iconLeft, iconRight, breakpoint.variant);
    return {
      ...breakpoint,
      variant: adjustedVariant
    };
  });
  const Comp = as;
  const btnType = type;
  const btnVariant = hasIcon(iconLeft, iconRight, variant);
  const responsiveVariantClass = responsiveStyles({ theme, breakpoints: formattedBreakpoints }).variant;
  return /* @__PURE__ */ jsxs(
    Comp,
    {
      "data-testid": testId,
      onClick,
      className: `${cx(
        buttonStyles.base,
        buttonStyles.type[btnType](theme),
        buttonStyles.variant[btnVariant],
        responsiveVariantClass,
        isPressedState ? "is-pressed" : null
      )} ${className}`,
      type: htmlType,
      tabIndex,
      ...rest,
      children: [
        iconLeft && /* @__PURE__ */ jsx(ButtonIcon, { icon: iconLeft }),
        children,
        iconRight && /* @__PURE__ */ jsx(ButtonIcon, { icon: iconRight })
      ]
    }
  );
}
Button.propTypes = {
  /** Defines the what element the button will be rendered as */
  as: PropTypes.string,
  /** Name of button size, e.g. "small" or "medium"  */
  variant: PropTypes.oneOf(["small", "medium"]).isRequired,
  /** Name of button style, as defined in the UIKit */
  type: PropTypes.oneOf(["critical", "nav-outline", "nav-filled", "nav-text", "outline", "filled", "text", "outline-icon", "icon"]).isRequired,
  /** Array of objects for media or container queries - each specifies size:string (breakpoint width) and variant, and optionally container (renders a container query if present) */
  breakpoints: PropTypes.arrayOf(
    PropTypes.shape({
      variant: PropTypes.string,
      size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      container: PropTypes.string
    })
  ),
  isPressedState: PropTypes.bool,
  tabIndex: PropTypes.number
};
export {
  Button as B
};
//# sourceMappingURL=Button-C3WhTBAE.js.map
